import { ActionCardTone as e } from "../types/ActionCardTone.mjs";
import { css as t, styled as n } from "styled-components";
//#region src/components/ActionCard/styled/ActionCard.styled.ts
var r = t`
    ${({ theme: n, $tone: r }) => {
	switch (r) {
		case e.Blocker: return t`
                    --action-accent: ${n.colors.destructive};
                    --action-accent-surface: ${n.palette.error.container};
                `;
		case e.Decision: return t`
                    --action-accent: ${n.colors.warning};
                    --action-accent-surface: ${n.colors.warningContainer};
                `;
		case e.Opportunity: return t`
                    --action-accent: ${n.colors.success};
                    --action-accent-surface: ${n.colors.successContainer};
                `;
		default: return t`
                    --action-accent: ${n.colors.mutedForeground};
                    --action-accent-surface: ${n.colors.muted};
                `;
	}
}}
`, i = n.div`
    ${r};
    position: relative;
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1.5)};
    padding: ${({ theme: e }) => e.spacing(1)};
    border-radius: ${({ theme: e }) => e.radii.md};
    background-color: transparent;
    cursor: ${({ $interactive: e }) => e ? "pointer" : "default"};
    transition: background-color ${({ theme: e }) => e.transitions.fast};

    ${({ $interactive: e, theme: n }) => e && t`
            &:hover {
                background-color: ${n.colors.muted};
            }
            &:focus-visible {
                outline: 2px solid ${n.colors.ring};
                outline-offset: -2px;
            }
        `}
`, a = n.div`
    position: relative;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: ${({ theme: e }) => e.radii.md};
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--action-accent-surface);
    color: var(--action-accent);

    svg {
        width: 18px;
        height: 18px;
    }
`, o = n.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme: e }) => e.spacing(.25)};
    flex: 1;
    min-width: 0;
`, s = n.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme: e }) => e.spacing(1)};
`, c = n.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--action-accent);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`, l = n.span`
    display: inline-flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(.5)};
    flex-shrink: 0;
    padding: ${({ theme: e }) => `${e.spacing(.25)} ${e.spacing(1)}`};
    border-radius: ${({ theme: e }) => e.radii.full};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.medium};
    /* The card's one numeric slot; a ticking countdown must not wobble the pill. */
    font-variant-numeric: tabular-nums;
    background-color: ${({ theme: e, $urgent: t }) => t ? e.palette.error.container : e.colors.muted};
    color: ${({ theme: e, $urgent: t }) => t ? e.colors.destructiveHover : e.colors.mutedForeground};

    svg {
        width: 12px;
        height: 12px;
    }
`, u = n.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: ${({ theme: e }) => e.spacing(1)};
`, d = n.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.base};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.foreground};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
`, f = n.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`, p = n.div`
    display: flex;
    align-items: baseline;
    gap: ${({ theme: e }) => e.spacing(.5)};
    flex-shrink: 0;
`, m = n.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.base};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.foreground};
    white-space: nowrap;
`, h = n.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    white-space: nowrap;
`, g = n.span`
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    color: ${({ theme: e }) => e.colors.mutedForeground};

    svg {
        width: 18px;
        height: 18px;
    }
`, _ = n.span`
    position: absolute;
    top: ${({ theme: e }) => e.spacing(.25)};
    inset-inline-end: ${({ theme: e }) => e.spacing(.25)};
    display: inline-flex;
    align-items: center;
    justify-content: center;

    button {
        width: 22px;
        height: 22px;
        min-height: 0;
        padding: 0;
    }
`;
//#endregion
export { o as Body, i as Card, g as Chevron, _ as DismissSlot, m as Figure, h as FigureCaption, p as FigureGroup, c as Kicker, a as Media, f as Meta, d as Title, u as TitleRow, s as TopRow, l as UrgencyPill };
